import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { eventTasksApi } from '../services/api/event-tasks.api';

const STALE_TIME_MS = 30_000;
const REFETCH_INTERVAL_MS = 60_000;

export const useTasksBadge = () => {
  const { data: response, isLoading } = useQuery({
    queryKey: ['tasks', 'my', 'badge'],
    queryFn: () => eventTasksApi.getUserTaskStats(),
    staleTime: STALE_TIME_MS,
    refetchInterval: REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
  });

  const badgeCount = useMemo(() => {
    const stats = response?.data;
    if (!stats) return 0;
    return (stats.inProgressTasks ?? 0) + (stats.overdueTasks ?? 0);
  }, [response?.data]);

  return { badgeCount, isLoading };
};

